import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogActions, MatDialogClose, MatDialogTitle,
  MatDialogContent, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SaveMultiPdfDialogData } from '../../../../models/reports/SaveMultiPdfDialogData';
import { SaveMultiPdfDialogResult } from '../../../../models/reports/SaveMultiPdfDialogResult';
import { IMultiPdfGroupForm } from '../../../../models/reports/IMultiPdfGroupForm';


@Component({
  selector: 'app-save-multi-pdf-dialog',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    TranslatePipe,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './save-multi-pdf-dialog.component.html',
  styleUrl: './save-multi-pdf-dialog.component.scss'
})
export class SaveMultiPdfDialogComponent implements OnInit {
  multiPdfSaveForm!: FormGroup<IMultiPdfGroupForm>;

  constructor(
    private readonly fb: NonNullableFormBuilder,
    public dialogRef: MatDialogRef<SaveMultiPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveMultiPdfDialogData
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.multiPdfSaveForm = this.fb.group({
      selectionName: this.fb.control(this.data.selectionName ?? '', [Validators.required]),
      description: this.fb.control(this.data.description ?? '')
    });
  }

  onSave(): void {
    if (this.multiPdfSaveForm.valid) {
      const result: SaveMultiPdfDialogResult = {
        selectionName: this.multiPdfSaveForm.controls.selectionName.value.trim(),
        description: this.multiPdfSaveForm.controls.description.value.trim()
      };
      this.dialogRef.close(result);
    }
  }
}
